import React from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";

const LinkComponent = (props) => {
  const { text, record, pathTarget } = props;
  let location = useLocation();

  let pathname = "";
  switch (pathTarget) {
    case "branch":
      pathname = `/branches/${record.id}/clients`;
      break;
    case "client":
      pathname = location.pathname + "/" + record.id;
      break;

    case "user":
      pathname = location.pathname + "/" + record.id;
      break;

    default:
      pathname = ``;
      break;
  }

  return (
    <Link
      style={{ color: "inherit", textDecoration: "underline" }}
      to={{
        pathname: pathname,
        // category: "profile",
      }}
    >
      <div className="content">{text}</div>
    </Link>
  );
};

export default LinkComponent;
